import React, { useState } from "react";
import Radio from "@material-ui/core/Radio";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import RadioGroup from "@material-ui/core/RadioGroup";
import classNames from "classnames";
import { getSafeOrDefault } from "../../../util/object-util";
import { useEventContext } from "../../../state/events/context";
import gamePeriodStyles from "../styles/GamePeriod.styles";
import { useGameContextContext } from "../../../state/game-context/context";
import NumberFormat from "../../../util/number-format";

const GamePeriod = ({ onChange, disabled, selectedPeriod }) => {
	const classes = gamePeriodStyles({ darkMode: !!selectedPeriod });

	const { state: eventState } = useEventContext();
	const currentEventSettings = eventState.currentEventSettings();
	const periodsInRegulation = getSafeOrDefault(
		() => currentEventSettings.gameConfiguration.general.periodsInRegulation
	);

	const { state } = useGameContextContext();
	const otPeriod = state.overtimePeriod();
	const period = state.period();
	const gameConfig = state.gameConfig();
	const isFootball = gameConfig.general.otTimeControl !== undefined;
	const periodNumber = period || 1;
	const nextPeriodNumber = periodNumber + 1;

	const [currentPeriodNumber, setCurrentPeriodNumber] = useState(
		selectedPeriod || periodNumber
	);

	const periods = [];
	const overtimes = 1;
	for (let i = 1; i <= periodsInRegulation + overtimes; i += 1) {
		periods.push(i);
	}

	const onPeriodSelected = (value) => {
		setCurrentPeriodNumber(value);
		if (onChange) {
			onChange(value);
		}
	};

	return (
		<RadioGroup
			row
			name="periods"
			value={currentPeriodNumber}
			onChange={(e) => onPeriodSelected(parseInt(e.target.value, 10))}
			className={classes.radioGroup}
		>
			{periods.map((p) => {
				const label =
					p <= periodsInRegulation
						? NumberFormat.withOrdinal(p).toUpperCase()
						: `OT${otPeriod || p - periodsInRegulation}`;

				if (p < periodNumber || p > nextPeriodNumber) {
					const isOt = isFootball && p > periodsInRegulation && !!otPeriod;
					return (
						<FormControlLabel
							id={`radio-button-${label}`}
							key={`radio-button-${label}`}
							value={isOt ? periodNumber : p}
							checked={isOt ? currentPeriodNumber === periodNumber : p < periodNumber}
							control={<Radio color="primary" />}
							label={label}
							labelPlacement="bottom"
							disabled={!isOt}
							className={classNames(classes.period, {
								[classes.periodComplete]: p < periodNumber && !disabled,
								[classes.periodDisabled]: p > periodNumber || disabled
							})}
						/>
					);
				}

				return (
					<FormControlLabel
						id={`radio-button-${label}`}
						key={`radio-button-${label}`}
						value={p}
						checked={p === currentPeriodNumber}
						control={<Radio color="primary" />}
						label={label}
						labelPlacement="bottom"
						disabled={disabled}
						className={classNames(classes.period, {
							[classes.periodDisabled]: disabled
						})}
					/>
				);
			})}
			{isFootball && otPeriod ? (
				<FormControlLabel
					id="radio-button-ot-plus-one"
					value={otPeriod + periodsInRegulation + 1}
					control={<Radio color="primary" />}
					label={`OT${otPeriod + 1}`}
					labelPlacement="bottom"
					disabled={disabled}
					className={classNames(classes.period, {
						[classes.periodDisabled]: disabled
					})}
				/>
			) : (
				""
			)}
		</RadioGroup>
	);
};

export default GamePeriod;
